import React from 'react'
import { Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { IPagination } from '@/model/types/common'
import { getMemberTablePagination, getTableTotal } from '../../table-utils'
import { RECORD_PAGE_SIZE } from './record-utils'

interface Props<T> {
    rowKey: string | ((record: T, index?: number) => React.Key)
    loading?: boolean
    columns: ColumnsType<T>
    dataSource: T[]
    page: number
    pageSize?: number
    pagination?: IPagination
    onPageChange: (page: number) => void
    onPageSizeChange?: (page: number, size: number) => void
}

function MemberRecordTable<T extends object>(props: Props<T>) {
    const pageSize = props.pageSize || RECORD_PAGE_SIZE

    return (
        <div className="table-container member-detail__record-table">
            <Table<T>
                bordered
                rowKey={props.rowKey}
                loading={props.loading}
                columns={props.columns}
                dataSource={props.dataSource}
                pagination={getMemberTablePagination({
                    current: props.page,
                    pageSize,
                    total: getTableTotal(props.pagination),
                    onChange: props.onPageChange,
                    onShowSizeChange: (nextPage, nextSize) => {
                        if (props.onPageSizeChange) props.onPageSizeChange(nextPage, nextSize)
                    },
                })}
                scroll={{ x: 'max-content' }}
            />
        </div>
    )
}

export default MemberRecordTable
